var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 43,
    viewBox: "0 0 96 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 39C17.64 39 19.1067 17.641 33.3333 17.641C47.4133 17.641 48.7333 28.0513 62.6667 28.0513C77.2235 28.0513 78.5067 4 92 4",
    stroke: "url(#paint0_linear_8828_67808)",
    strokeWidth: 6.13125,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8828_67808",
    x1: 38.082,
    y1: 30.9444,
    x2: 103.475,
    y2: 5.20785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0265067,
    stopColor: "#D397E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFF48"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentWave);
export default __webpack_public_path__ + "static/media/PaymentWave.3a14420704712750d52c075b11d26246.svg";
export { ForwardRef as ReactComponent };